<template>
  <div id="debug-view">
    <h1>echoslip debug</h1>
    <div id="debug-log">
      <p v-for="msg in outputLog" :key="msg">{{ msg }}</p>
    </div>
    <div>
      <button @click="sendCommand('run deck = new Deck({cards: [1,2,3,4,5]})')">reset</button>
      <button @click="sendCommand('run deck.cards')">cards</button>
      <button @click="sendCommand('run deck.discard')">discard</button>
      <button @click="sendCommand('run deck.active')">active</button>
      <button @click="sendCommand('run deck.shuffle()')">shuffle()</button>
      <button @click="sendCommand('run deck.draw()')">draw()</button>
      <button @click="sendCommand('run deck.mill()')">mill()</button>
      <button @click="sendCommand('run deck.pick(1)')">pick(1)</button>
      <button @click="sendCommand('run deck.isEmpty()')">isEmpty()</button>
    </div>
    <div>
      <input v-model="command" />
      <button @click="sendCommand(command)">eval</button>
    </div>
  </div>
</template>

<script>
import { io } from 'socket.io-client'

const socket = io();

export default {
  name: 'DebugView',
  data () {
    return {
      socket: socket,
      outputLog: [],
      command: '',
    }
  },
  methods: {
    log (msg) {
      this.outputLog.push(msg);
    },
    sendCommand (command) {

      this.socket.emit('command', command);
      this.command = '';
    }
  },
  mounted () {
    this.socket.on('connect', () => {
      console.log('socket connected');
    });

    this.socket.on('log', msg => {
      console.log('log received');

      this.log(msg);
    });
  },
  beforeUnmount () {
    this.socket.disconnect();
  }
}
</script>

<style>
#debug-view {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#debug-log {
  display: flex;
  flex-direction: column;

  height: 70vh;
  width: 40rem;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, .2);

  padding: 1rem;
  margin: 1rem;
}

#debug-log p {
  padding: .2rem;
  margin: 0px;
}

#debug-log :nth-child(even) {
  background-color: rgba(0, 0, 0, .1);
}

</style>